import { createFileRoute, Outlet } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  status: z.enum(['PUBLISHED', 'HIDDEN']).optional(),
  search: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/news')({
  staticData: { breadcrumb: 'Новости' },
  validateSearch: searchSchema,
  component: () => <Outlet />,
});
